<template>
  <div class="web">
    <div class="pc-box">
      <!--搜索-->
      <div class="pc-search">
        <div class="pc-search-auto">
          <h2><a href="javascript:history.back(-1);">师生互选</a>&nbsp;&gt; 教师列表</h2>
          <van-search
                  v-model="queryParams.name"
                  show-action
                  placeholder="请输入搜索关键词"
                  @search="onSearch"
                  :clearable="false"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </div>
      </div>

      <div class="pc-list">
        <!-- tab -->
        <div class="c-class">
          <van-tabs v-model="queryParams.status" animated title-active-color="#2C68E4" :border="false"
                    @change="tabChange">
            <van-tab title="导师列表" name=""/>
            <van-tab title="待确认列表" name="0"/>
          </van-tabs>
        </div>
        <!-- tab -->
        <!--<div class="c-class">-->
        <!--  <van-tabs v-model="queryParams.faculty" animated title-active-color="#2C68E4" :border="false" @change="tabChange">-->
        <!--    <van-tab title="全部" name=""/>-->
        <!--    <van-tab v-for="(item, index) in facultyTypeOptions" :title="item.label" :name="item.value" :key="index"/>-->
        <!--  </van-tabs>-->
        <!--</div>-->

        <!-- 导师列表数据 -->
        <van-pull-refresh v-model="data.topLoading" @refresh="refresh()" v-if="!queryParams.status">
          <van-list
                  v-model="data.bottomLoading"
                  :finished="!data.hasMore"
                  finished-text="没有更多了"
                  @load="onLoad"
          >
            <div class="tech-list" v-for="(item, index) in data.records" :key="index">
              <img class="xz" src="@/assets/select.png" v-if="item.chooseStatus === '1'">
              <div class="tech-top" @click="toDetail(item)">
                <!--<van-image fit="contain" :src="fileDisplayPrefix + item.header"/>-->
                <div class="top-r">
                  <h2 class="info-item">
                    {{ item.name }}
                    <em class="guide-max" v-if="item.selectCount >= item.maxCount">名额已满</em>
                  </h2>
                  <!--<div class="tech-info" v-html="item.content"></div>-->
                  <div class="info-item">指导学生名额：{{ item.maxCount }}人</div>
                  <div class="info-item" v-if="item.professionalTitle">职称：{{ item.professionalTitle }}</div>
                  <div class="info-item" v-if="item.enrollmentDirection">招生专业：{{ item.enrollmentDirection }}</div>
                  <div class="info-item" v-if="item.category">导师类别：{{ item.category }}</div>
                </div>
              </div>
              <!--无状态或已取消、老师绑定学生数量小于最大可选数、当前学生没有选择老师 可选-->
              <div v-if="(!item.chooseStatus || ['2', '3', '4', '5'].includes(item.chooseStatus)) && item.selectCount < item.maxCount && !notSelect"
                   class="tech-bottom">
                <a @click="toDetail(item)">选择老师</a>
              </div>
              <!--发起人是学生并且状态待确认,显示取消选择-->
              <div v-if="item.chooseType === '1' && item.chooseStatus === '0'" class="tech-bottom">
                <a @click="cancel(item)">取消选择</a>
              </div>
              <!--发起人是老师并且状态待确认,显示待确认-->
              <div v-if="item.chooseType === '0' && item.chooseStatus === '0'" class="tech-bottom">
                <a style="color: #888888; border: none">待确认</a>
              </div>
              <!--已确认状态学生可以评价-->
              <!--<div v-if="item.chooseStatus === '1'" class="tech-bottom">-->
              <!--  <van-button type="info" @click="toDetail(item)">立即评价</van-button>-->
              <!--</div>-->
            </div>
          </van-list>
        </van-pull-refresh>
        <!--待确认列表-->
        <van-pull-refresh v-model="data.topLoading" @refresh="refresh()" v-if="queryParams.status === '0'">
          <van-list
                  v-model="data.bottomLoading"
                  :finished="!data.hasMore"
                  finished-text="没有更多了"
                  @load="onLoad"
          >
            <div class="tech-list" v-for="(item, index) in data.records" :key="index">
              <!--          <img class="xz" src="@/assets/select.png" v-if="item.chooseStatus === '1'">-->
              <div class="tech-head" @click="toDetail(item)">
                <div class="tech-l">
                  <h2>{{ item.chooseType === '1' ? `你邀请的${item.name}老师` : `${item.name}老师邀请的你` }}</h2>
                  <em :class="`status${item.chooseStatus}`">{{ getDictName(chooseStatusOptions, item.chooseStatus) }}</em>
                  <!-- 拒绝加class="red" 拒绝加class="blue" -->
                </div>
                <i class="time1">{{item.chooseTime}}</i>
                <div class="pctime">
                <div class="tech-cen" v-html="item.chooseRemark"></div>
                  <i class="time3">{{item.chooseTime}}</i>
                </div>
              </div>
              <!--发起人是老师并且状态待确认,显示同意/拒绝-->
              <div class="tech-bottoms" v-if="item.chooseType === '0' && item.chooseStatus === '0'">
<!--                <i class="time2">{{item.chooseTime}}</i>-->
                <div class="buttonstyle">
                  <van-button type="info" @click="affirmConfirm(item, '1')">同意</van-button>
                  <van-button type="info" @click="affirmConfirm(item, '3')">拒绝</van-button>
                </div>
              </div>
              <!--发起人是学生并且状态待确认,显示修改备注/取消选择-->
              <div class="tech-bottoms" v-if="item.chooseType === '1' && item.chooseStatus === '0'">
<!--                <i class="time2">{{item.chooseTime}}</i>-->
                <div class="buttonstyle">
                  <van-button class="editbut" type="info" @click="$refs.remark.show(item.chooseRemark, item.chooseId)">
                    修改备注
                  </van-button>
                  <van-button type="info" @click="cancel(item)">取消选择</van-button>
                </div>
              </div>
              <!--状态为已作废/拒绝、老师绑定学生数量小于最大可选数、当前学生没有选择老师 可选-->
              <div class="tech-bottoms"
                   v-if="['2', '3', '4', '5'].includes(item.chooseStatus) && item.selectCount < item.maxCount && !notSelect">
<!--                <i class="time2">{{item.chooseTime}}</i>-->
                <div class="buttonstyle">
                  <van-button type="info" @click="toDetail(item)">再次选择</van-button>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
        <remark ref="remark" title="修改备注" @handleOk="updateChooseRemark"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {Dialog} from 'vant';
  import {getDictByType} from '@/api/common'
  import {getDictName} from '@/utils/common'
  import {
    queryList,
    chooseTeacher,
    cancelChoose,
    affirmChoose,
    updateChooseRemark,
    checkStudentBind
  } from '@/api/teacher/teacherInfo'
  import {handlePageData} from '@/utils/common'
  import remark from "./components/remark";

  export default {
    name: 'teacherList',
    components: {
      remark
    },
    data() {
      return {
        getDictName,
        activeId: '',
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        queryParams: {},
        data: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
        facultyTypeOptions: [],
        chooseStatusOptions: [
          {label: '待确认', value: '0'},
          {label: '已确认', value: '1'},
          {label: '已取消', value: '2'},
          {label: '已拒绝', value: '3'},
          {label: '已作废', value: '4'},
          {label: '导师名额已满', value: '5'},
        ],
        notSelect: true
      }
    },
    created() {
      this.queryParams.activityId = this.$route.query.id
      this.getDict();
      this.refresh()
      // 检查学生是否已经绑定教师
      checkStudentBind(this.queryParams.activityId).then(res => {
        if (res.code === 10000) {
          this.notSelect = res.result || false
        }
      })
    },
    methods: {
      // 数据字典
      getDict() {
        // 查询字典，院系类型
        getDictByType('faculty_type').then(res => {
          if (res.code === 10000) {
            this.facultyTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
      // 刷新列表
      refresh() {
        this.reset();
        this.getDataList();
      },
      reset() {
        this.data.current = 1;
        this.data.total = 0;
        this.data.hasMore = true
      },
      // 加载数据
      onLoad() {
        if (this.data.current > 1 && this.data.hasMore) {
          this.getDataList()
        }
      },
      // 获取列表数据
      getDataList() {
        if (this.data.loading) return;
        this.data.loading = true;
        this.queryParams.current = this.data.current;
        this.queryParams.size = this.data.size;
        queryList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.data, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.data.loading = false;
            this.data.topLoading = false;
            this.data.bottomLoading = false
          }, 100)
        })
      },
      // tab切换回调方法
      tabChange() {
        this.$nextTick(() => {
          this.data.records = [];
          this.refresh()
        })
      },
      chooseTeacher(teacher) {
        const data = {
          teacherId: teacher.id,
          status: '0'
        };
        chooseTeacher(data).then(res => {
          if (res.code === 10000) {
            this.$toast(res.msg)
          }
        }).finally(() => {
          setTimeout(() => {
            this.refresh()
          }, 100)
        })
      },
      onSearch() {
        this.refresh()
      },
      toDetail(item) {
        this.$router.push({path: `/activity/teacherDetail?id=${item.id}&activityId=${this.queryParams.activityId}`});
      },
      cancel(item) {
        Dialog.confirm({
          title: '取消选择',
          message: '确认取消吗?',
          theme: 'round-button',
        }).then(() => {
          this.cancelChoose(item);
        }).catch(() => {
        });
      },
      cancelChoose(teacher) {
        const data = {
          id: teacher.chooseId,
          teacherId: teacher.id,
          status: '2'
        };
        cancelChoose(data).then(res => {
          if (res.code === 10000) {
            this.$toast(res.msg)
          }
        }).finally(() => {
          setTimeout(() => {
            this.refresh()
          }, 100)
        })
      },
      affirmConfirm(item, status) {
        Dialog.confirm({
          title: '提示',
          message: '确认此选择吗?',
          theme: 'round-button',
        }).then(() => {
          this.affirm(item, status)
        }).catch(() => {
        });
      },
      affirm(item, status) {
        const data = {
          id: item.chooseId,
          status
        }
        affirmChoose(data).then(res => {
          if (res.code === 10000) {
            this.$toast(res.msg)
          }
        }).finally(() => {
          setTimeout(() => {
            this.refresh()
          }, 100)
        })
      },
      updateChooseRemark(remark, paramId) {
        const data = {
          id: paramId,
          remark
        }
        updateChooseRemark(data).then(res => {
          if (res.code === 10000) {
            this.$toast(res.msg)
          }
        }).finally(() => {
          setTimeout(() => {
            this.refresh()
          }, 100)
        })
      }
    }
  }
</script>

<style scoped>
.pc-search h2{
  display:none;
}
  .info-item {
    margin: 2px 0;
    font-size: 14px;
    line-height: 1.5;
  }

  .info-item .guide-max {
    height: 16px;
    background: #FF0000;
    border-radius: 3px;
    padding: 0 2px;
    font-size: 11px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    margin-left: 5px;
  }

  .van-cell__value {
    text-align: left;
  }

  .van-card__thumb {
    width: 30%;
  }

  .van-card__footer {
    margin-top: 20px;
    text-align: center;
  }

  .tech-list {
    /*height: 156px;*/
    background: #FFFFFF;
    border-radius: 6px;
    margin: 10px 0;
    position: relative;
    overflow: hidden;
  }

.tech-top {
  display: flex;
  padding: 10px;
  /*height: 105px;*/
  /*border-bottom: 1px solid #dedede;*/
}

  /deep/ .van-image {
    display: flex;
    width: 76px;
    height: 88px;
    margin-right: 10px;
  }

  .top-r {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .top-r h2 {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
  }

  .tech-info {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .tech-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 51px;
  }

  /deep/ .van-button--info {
    width: 116px;
    height: 32px;
    background: #2C68E4;
    border-radius: 3px;
  }

  .xz {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
  }

  .tech-bottom a {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2C68E4;
  }


  .tech-head {
    padding: 0 10px 10px 10px;
  }

  .tech-l {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0 10px 0;
  }

  .tech-l h2 {
    font-weight: bold;
    font-size: 16px;
  }

  .tech-l em {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    border-radius: 100px;
    padding: 4px 5px;
    background: #e8e8e8;
    color: #666666;
  }

  .tech-l em.status0 {
    background: #ff9900;
    color: #ffffff;
  }

  .tech-l em.status1 {
    background: #26b500;
    color: #ffffff;
  }

  .tech-l em.status2 {
    background: #2C68E4;
    color: #ffffff;
  }

  .tech-l em.status3 {
    background: #ff0000;
    color: #ffffff;
  }

  .tech-l em.status4 {
    background: #e8e8e8;
    color: #666666;
  }

  .tech-l em.status5 {
    background: #e8e8e8;
    color: #666666;
  }

  .tech-cen {
    font-size: 12px;
    color: #666666;
    line-height: 19px;
    padding-bottom: 0;
    margin-top: 5px;
    position: relative;
    top: -8px;
  }

  .tech-bottoms {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-top: 1px solid #dedede;
  }
.tech-head i {
  font-size: 12px;
  color: #999999;
}
  .tech-bottoms i {
    font-size: 12px;
    color: #999999;
  }

  .buttonstyle {
    display: flex;
    align-items: center;
  }
.tech-head .time1{
  display: none;
}
.pctime .time3{
  display: block;
}
  /deep/ .van-button--info {
    width: auto;
    height: auto;
    padding: 6px 10px;
    margin-left: 5px;
    border: none;
    background: #2C68E4;
  }

  .editbut {
    border: 1px solid #2C68E4;
    background: #ffffff;
    color: #2C68E4;
  }
  @media screen and (min-width:1024px){
    .pc-search{
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffff;
    }
    .pc-search h2{
      display: flex;
      padding: 0 20px;
      font-size:18px;
      font-weight: 600;
    }
    .pc-search-auto{
      width: 1024px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .pc-search-auto h2 a{
      padding: 0 10px 0 0;
      font-size:18px;
      font-weight: 600;
    }
    .pc-box{
      margin: 0 auto;
    }
    .pc-list{
      width: 1024px;
      margin: 0 auto;
    }
    .c-class{
      margin: 0 10px;
      margin-top: 10px;
      border-bottom: 1px solid #dedede;
    }
    .tech-list{
      margin: 0;
      border-radius: 0;
      padding: 0 15px;
      margin-bottom:1px;
      display: flex;
      justify-content: space-between;
    }
    .tech-top{
      border-bottom: 1px dashed  transparent;
      display: flex;
      flex: 1;
    }
    /deep/.van-tabs--line .van-tabs__wrap{
      height: 60px;
    }
    .tech-bottom a{
      border: 1px solid #2C68E4;
      border-radius: 100px;
      padding: 5px 10px;
    }
    .tech-bottoms{
      border-top: none;
      width: 260px;
      justify-content: flex-end;
    }
    .tech-head .time1{
      display: block;
    }
    .time2{
      display: none;
    }
    .tech-l em{
      margin-left: 15px;
      position: relative;
      top: 10px;
    }
    .tech-head{
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      flex: 1;
    }
    .pctime .time3{
      display: none;
    }
    .tech-cen {
      font-size: 12px;
      color: #666666;
      line-height: 19px;
      padding-bottom: 0;
      margin-top: 5px;
      position: relative;
      top: 0;
    }
  }
</style>
